const WidgetWithInlineLoaderOnCallbackMixin = {
    props: {
        showInlineLoaderOnCallback: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {
            showInlineLoader: false
        }
    },
    created() {
        if (this.showInlineLoaderOnCallback) {
            // Listen to the event that the functional wrapper is forcing this instance to emit
            this.$on('widget-event-callback-loading', (isLoading) => {
                this.showInlineLoader = isLoading;
            });
        }
    }
};

export default WidgetWithInlineLoaderOnCallbackMixin;